import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AviationEvent } from '../../shared/models/aviation-event.model';
import { MatDialog, MatDialogConfig, MatDialogRef, MatSnackBar } from '@angular/material';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { EditEventLocationComponent } from '../edit-event-location/edit-event-location.component';
import { AviationEventsService } from '../../shared/services/aviation-events.service';


@Component({
  selector: 'app-event-location',
  templateUrl: './event-location.component.html',
  styleUrls: ['./event-location.component.scss']
})
export class EventLocationComponent implements OnInit {
  @Input() aviationEvent: AviationEvent;
  @Output() dataChangedEvent = new EventEmitter<AviationEvent>();
  airportFuelTypesWithCommas: string;
  editModeSet = false;

  constructor(private _editDescDialog: MatDialog,
              private _toggleService: EditToggleService,
              public snackBar: MatSnackBar,
              private _aviationEventsService: AviationEventsService) { }


  ngOnInit() {
    this._toggleService.toggleEmitter.subscribe(isOn => {
      this.editModeSet = isOn;
    });
    if (this.aviationEvent.airportFuelTypes && this.aviationEvent.airportFuelTypes.length > 0) {
      this.airportFuelTypesWithCommas = this.aviationEvent.airportFuelTypes.join(', ');
    }
  }

  async reloadEntity() {
    this.aviationEvent = await this._aviationEventsService.getAviationEventById(this.aviationEvent.eventId);
    this.dataChangedEvent.emit(this.aviationEvent);
  }

  openEditLocationDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '900px';
    dialogConfig.data = {aviationEvent: this.aviationEvent};

    const DIALOG_REF = this._editDescDialog.open(EditEventLocationComponent, dialogConfig);
    this._handleModalClose(DIALOG_REF);
  }

  /**
   * listens for dialog close event. Opens snackbar if necessary
   * @param {MatDialogRef<any>} dialogRef
   * @private
   */
  _handleModalClose ( dialogRef: MatDialogRef<any>) {
    const ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';

    dialogRef.afterClosed().subscribe((success) => {
      if (success === null) { return; }
      if (success) {
        this.reloadEntity();
        this.snackBar.open('Event Venue/Location', 'Updated', {
          duration: 3000
        });
      } else {
        this.snackBar.open(ERROR_MSG, 'Error', {
          duration: 6000
        });
      }
    });
  }
}
